module.exports = __webpack_public_path__ + "static/spacing-aa2f73f60393a5769089e111373440f1.png";